import { Mixin } from 'mixwith';

export default Mixin(
  (superclass) =>
    class extends superclass {
       
      ignoreElementNode(representation) {
        return {
          id: representation.attributes.id,
          ignore: true,
        };
      }
    },
);
